// env.service.ts
import { Injectable } from '@angular/core';
import { Environment } from '../model/environment.interface';
import { lastValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ConfigService  {
  private config!: Environment;
  constructor(private http: HttpClient) {}

  loadConfig(): Promise<void> {
    return lastValueFrom(
      this.http.get<Environment>('assets/config/environment.json')
    )
    .then(config => {
      this.config = config;
    })
    .catch(error => {
      console.error('Error loading configuration:', error);
      throw error;
    });
  }


  getConfig(): Environment {
    if (this.config === null) {
      throw new Error('Configuration has not been loaded.');
    }
    return this.config;
  }
}
